// extracted by mini-css-extract-plugin
export var aboveInput = "_fn-0";
export var actionButton = "_fn-5";
export var actionButtonContainer = "_fn-1";
export var actionIcon = "_fn-6";
export var aiInfoContainer = "_fn-2";
export var attachmentWrapper = "_fn-7";
export var bold = "_fn-3";
export var checkIcon = "_fn-8";
export var clickingRecipientBar = "_fn-11";
export var commentThreadSwitch = "_fn-a";
export var draftImage = "_fn-b";
export var draftImageContainer = "_fn-c";
export var draftImages = "_fn-e";
export var editButton = "_fn-g";
export var editor = "_fn-f";
export var editorContainer = "_fn-y";
export var editorErrorTooltipWrapper = "_fn-9";
export var headerDivider = "_fn-h";
export var icon = "_fn-i";
export var info = "_fn-j";
export var internal = "_fn-n";
export var internalDivider = "_fn-k";
export var internalMessage = "_fn-l";
export var messageInputCard = "_fn-m";
export var messageInputForm = "_fn-o";
export var messageInputFormInternal = "_fn-p";
export var options = "_fn-q";
export var publicMessageCustomer = "_fn-s";
export var publicMessageMerchant = "_fn-r";
export var removeImageButton = "_fn-d";
export var replyButtons = "_fn-t";
export var showSignatureButton = "_fn-u";
export var spinner = "_fn-v";
export var verticalButtonDivider = "_fn-4";
export var visibilitySelector = "_fn-w";
export var warning = "_fn-x";
export var wrappingText = "_fn-z";
export var writingInternalNoteTopBorder = "_fn-10";